var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarTime = function SvgCalendarTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "inherit",
    height: "inherit",
    fill: "none",
    stroke: "var(--svg-stroke-color, inherit)",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "inherit",
    clipPath: "url(#calendar-time_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 23a8 8 0 1 0 16.001 0A8 8 0 0 0 15 23"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.536 23H23v-3.536M11 27H3a1.95 1.95 0 0 1-2-2V5.143A2.076 2.076 0 0 1 3 3h20a2.076 2.076 0 0 1 2 2.143V11M7 1v6M13 1v6M19 1v6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar-time_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
};
export default SvgCalendarTime;